import { Box, FormLabel, Select, SelectProps } from '@chakra-ui/react'

interface iFormProps extends SelectProps {
  title?: string
  value?: string
  OnChange: (e: string) => void
  isInvalid?: boolean
  mb?: string
  isDisabled?: boolean
  fontSize?: string
  somenteLeitura?: boolean
}

export const SelectCmp: React.FC<iFormProps> = ({ children, OnChange, title, value, w, h, width, isInvalid, mb, isDisabled, fontSize, minW, somenteLeitura }) => {
  return (
    <Box w={w} width={width} mb={mb} cursor={isDisabled ? 'not-allowed' : ''}>
      {title && <FormLabel color={'var(--Gray1)'} fontSize={'14px'} mb={'.25rem'}>{title}</FormLabel>}
      <Select
        pointerEvents={somenteLeitura ? 'none' : undefined}
        isInvalid={isInvalid}
        isDisabled={isDisabled}
        onChange={(e) => OnChange(e.target.value)}
        value={value}
        bg={'white'}
        borderColor={'var(--Gray4)'}
        size='xs' h={h ?? '1.975rem'}
        fontSize={fontSize ?? '.875rem'}
        w={width}
        minW={minW}
        sx={
          somenteLeitura
            ? {
                // esconde o ícone de dropdown do Chakra porque ele é um SVG
                '& + div > svg': { display: 'none' }
              }
            : undefined
        }
      >
        {children}
      </Select>
    </Box>
  )
}
